//@flow
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Modal from './modal';
import { unsavedChanges } from '../actions';
import { setSessionIdToUrl } from 'h-commons';
import { Typography, theme } from '@hiver/hiver-ui-kit';

/**
* This file is responsible for displaying the UnsavedChanges modal
* @author Jitin
*/
class UnsavedChanges extends Component<Props,State> {

    static defaultProps = {
        exceptions: []
    }

    constructor(props) {
        super(props);
        this.state = {
            openModal: false,
            nextLocation: null, 
            forceUnmount: false
        };
    }
    
    setOpenModal(state) {
        this.setState({
            openModal: state
        });
    }

    setNextLocation(nextLocation) {
        this.setState({
            nextLocation
        });
    }

    unblock() {
        this.removeBlock = this.props.history.block((nextLocation) => {
            const { forceUnmount } = this.state;
            const { unsaved, match, exceptions } = this.props;
            const { isUnsaved } = unsaved;
            const preventBlock = [...exceptions, match.url]
                            .includes(nextLocation.pathname)
            if(isUnsaved && !forceUnmount && !preventBlock) {
                this.setOpenModal(true);
                this.setNextLocation(nextLocation);
            }
            return !isUnsaved || forceUnmount || preventBlock;
        });
    }

    closeModal() {
        this.setOpenModal(false);
    }

    componentDidMount() {
        this.unblock();
        if (typeof this.props.getRef === 'function')
            this.props.getRef(this);
    }

    componentWillUnmount() {
        this.removeBlock();
        if (typeof this.props.getRef === 'function')
            this.props.getRef(null);
    }

    leave() {
        const { userSession } = this.props;
        this.setOpenModal(false);
        this.setState({
            forceUnmount: true
        },()=>{
            const { nextLocation } = this.state;
            nextLocation && this.props.history.push(setSessionIdToUrl(nextLocation.pathname, userSession));
            this.props.unsavedChanges(false);
            typeof this.props.onDiscard === 'function' && this.props.onDiscard();
        });
    }
    
    render() {
        const { openModal } = this.state;
        if(!openModal) {
            return null;
        }
        let { modalContent, primaryActionLabel } = this.props;
        const centerText = {
            textAlign: 'center'
        }
        modalContent = modalContent || (<div>
            <p className="h-h2" style={centerText}><Typography variant="h3">Are you sure you want to leave this page?</Typography></p>
            <p className="h-s3" style={centerText}><Typography variant="body2" sx={{color: theme.palette.gray.gray3}}>All unsaved data will be lost</Typography></p>
        </div>);
        return (
            <Modal
                shown={openModal}
                modalContent={modalContent}
                leftBtnText="Stay"
                rightBtnText={ primaryActionLabel|| "Leave" }
                leftBtnHandler={this.closeModal.bind(this)}
                rightBtnHandler={this.leave.bind(this)}
                leftBtnType="cancel"
                rightBtnType="warning"
            />
        );
    }
}

UnsavedChanges = withRouter(UnsavedChanges);

const mapStateToProps = ({ unsavedChanges, appModes: { userSession } }) => {
    return {
        unsaved: unsavedChanges,
        userSession
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        unsavedChanges: (state) => {
            dispatch(unsavedChanges(state));
        }
    };
};

type State = {
    openModal: boolean,
    nextLocation: string | null, 
    forceUnmount: boolean
}
type Props = {
    unsavedChanges: Function,
    exceptions?: Array<string>,
    unsaved: boolean,
    userSession: string | number
}
UnsavedChanges = connect(mapStateToProps, mapDispatchToProps)(UnsavedChanges);

export default UnsavedChanges;
export {
    UnsavedChanges
}